import { PlanCellCoordinatesWithOptionalPerson } from "../data/plan";
import React from "react";
import { usePersonsAsync } from "../queries/queries";
import { mealInds } from "../utils/mealIndUtils";
import { formatGermanDate } from "../utils/dateUtils";

export function PlanCoordinateHeader(props: {
  planMode?: "plan" | "intake";
  planCellCoordinates: PlanCellCoordinatesWithOptionalPerson | undefined;
}) {
  const persons = usePersonsAsync(false);
  if (!props.planCellCoordinates) {
    return <></>;
  }
  const personName = props.planCellCoordinates.personId
    ? persons.find((p) => p.id === props.planCellCoordinates!.personId)?.name
    : undefined;
  const mealIndDescription =
    mealInds[props.planCellCoordinates.mealInd]?.name || "";
  return (
    <div className="flex-1 min-w-0">
      <div className="font-bold leading-tight">
        {mealIndDescription}{" "}
        {props.planMode == "plan"
          ? "planen"
          : props.planMode
            ? "verzehren"
            : ""}
      </div>
      <div className="text-xs text-ink-muted mt-0.5">
        {formatGermanDate(props.planCellCoordinates.date)}
        {personName && (
          <span>
            {" · "}
            <span className="font-medium">{personName}</span>
          </span>
        )}
      </div>
    </div>
  );
}
